import { AlertTriangle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useSEO } from "@/components/seo";
import { Reveal, SectionHead } from "@/components/motion";

export default function Legal({ kind }) {
  const { t } = useLang();
  useSEO(kind);
  const page = t.legal[kind];

  return (
    <div className="bg-anthracite-dark pt-16" data-testid={`legal-${kind}-page`}>
      <section className="border-b border-white/10 bg-anthracite grid-lines-dark">
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:py-24">
          <SectionHead kicker="R-Mechanik SRLS" title={page.title} light testid={`legal-${kind}`} />
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-8">
        <Reveal>
          <div className="flex items-start gap-3 border border-amber-400/40 bg-amber-400/10 p-5" data-testid="legal-draft-badge">
            <AlertTriangle size={18} className="mt-0.5 shrink-0 text-amber-300" />
            <p className="text-sm text-amber-200">{t.legal.draftBadge}</p>
          </div>
        </Reveal>

        {kind === "cookies" && (
          <Reveal delay={0.08}>
            <p className="mt-10 leading-relaxed text-slate-300">{page.intro}</p>
            <button
              onClick={() => window.dispatchEvent(new Event("rm-open-cookie-settings"))}
              className="mt-6 bg-royal px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-royal-hover"
              data-testid="cookies-open-settings"
            >
              {page.openSettings}
            </button>
            <p className="mt-6 text-sm text-slate-500">{page.currentState}</p>
          </Reveal>
        )}

        {page.sections && (
          <div className="mt-10 space-y-0">
            {page.sections.map((s, i) => (
              <Reveal key={s.heading} delay={i * 0.05}>
                <div className="border-t border-white/10 py-8 last:border-b" data-testid={`legal-section-${i}`}>
                  <h2 className="flex items-center gap-4 text-lg font-bold text-white">
                    <span className="font-mono-tech text-sm text-royal-soft">0{i + 1}</span>
                    {s.heading}
                  </h2>
                  <p className="mt-4 whitespace-pre-line pl-9 text-sm leading-relaxed text-slate-400">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
